import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import { bidsModalHide } from "../../redux/counterSlice";
import {getWalletBalances, syncTransactions, transfer} from "../../utils/api";
import { useRouter } from "next/router";
import ExchangeData from "../../data/exchange_data";
import {getAccountHolderId, getUserId} from "../../utils/jwtUtil";
import Spinner from "../Spinner"
import {Alert} from "@mui/material";

const BidsModal = () => {
  const { bidsModal, projectData } = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [selectedExchange, setSelectedExchange] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [balanceForProject, setBalanceForProject] = useState(0);
  const [balanceForProjectString, setBalanceForProjectString] = useState("");
  const [cadrsAmount, setCadrsAmount] = useState(1); // State for CADRs amount
  const [accountHolderId, setAccountHolderId] = useState(null);

  // Assuming you have access to the user's locale, otherwise use the browser's default locale
  
  const router = useRouter();
  
  const { data: walletBalancesData, error: walletBalancesError} = getWalletBalances(accountHolderId);

  useEffect(() => {
    setAccountHolderId(getAccountHolderId());
  },[]);
  
  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage(""); // Clear the success message after 5 seconds
      }, 5000);

      return () => clearTimeout(timer); // Clear the timer on component unmount
    }
  }, [successMessage]);
  
  useEffect(() => {
    if (!walletBalancesData || !Array.isArray(walletBalancesData)) return;
    if (!projectData) return;
    const projectBalanceForUser = walletBalancesData.find(x => x.projectId === projectData.projectId && x.walletAccountType === "Server");
    if (projectBalanceForUser) {
      setBalanceForProject(projectBalanceForUser);

      const userLocale = navigator.language || 'en-AU';
      setBalanceForProjectString(new Intl.NumberFormat(userLocale).format(projectBalanceForUser.balance));
    }
  }, [walletBalancesData, projectData]);
  
  const handleExchangeChange = (id) => {
    const exchange = ExchangeData.find((exchange) => exchange.id === id);
    setSelectedExchange(exchange);
  };

  function handleCadrsAmountChange(e) {
    setCadrsAmount(e.target.value); // Update the state with input value
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setIsButtonDisabled(true);
    setIsLoading(true); // Show spinner
    try {
      await transfer({
        from: balanceForProject.walletAccountId,
        to: selectedExchange.walletAccountId,
        tokenId: balanceForProject.tokenId,
        amount: Number(cadrsAmount), // Use the state variable here
      });
      setSuccessMessage("Transfer successful!");

      setTimeout(() => {
        window.location.href = "/activity";
      }, 3000); // Redirect after 3 seconds
      
      // sync 
      await syncTransactions();
      
    } catch (error) {
      console.error("Error performing transfer:", error);
    } finally {
      setIsButtonDisabled(false);
      setIsLoading(false); // Hide spinner
    }
  }
  
  return (
    <div>
      <div className={bidsModal ? "modal fade show block" : "modal fade"}>
        <div className="modal-dialog max-w-2xl custom-modal-width">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="placeBidLabel">
                Transfer for Sale
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => dispatch(bidsModalHide())}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"></path>
                </svg>
              </button>
            </div>

            {/* <!-- Body --> */}
            <div className="modal-body p-6">
              <div className="mb-2 flex items-center justify-between">
              <span className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
                Amount
              </span>
              </div>

              <div
                  className="dark:border-jacarta-600 border-jacarta-100 relative mb-2 flex items-center overflow-hidden rounded-lg border">
                <div className="border-jacarta-100 bg-jacarta-50 flex flex-1 items-center self-stretch border-r px-2">
                <span className="font-display text-jacarta-700 text-sm">
                    CADRs
                  </span>
                </div>

                <input
                    type="number"
                    className="focus:ring-accent h-12 w-full flex-[3] border-0 focus:ring-inse dark:text-jacarta-700"
                    placeholder="Amount"
                    min={0}
                    value={cadrsAmount} // Bind the state to input
                    max={balanceForProject.balance}
                    onBlur={() => {
                      if (cadrsAmount > balanceForProject.balance) {
                        setCadrsAmount(balanceForProject.balance);
                      }
                      else if (cadrsAmount < 1) {
                        setCadrsAmount(1);
                      }
                    }}
                    onChange={handleCadrsAmountChange} // Update state on change
                />
              </div>

              <div className="text-right">
                <span className="dark:text-jacarta-400 text-sm">
                  Balance: {balanceForProjectString} CADRs
                </span>
              </div>
              
              
            </div>

            <div className="modal-body p-6">
              <div className="mb-2 flex items-center justify-between">
                <span className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
                  Select an Exchange
                </span>
              </div>
              <div className="mt-2">
                {Array.isArray(ExchangeData) && ExchangeData.map((item) => (
                    <div key={item.projectId + item.bundleId + item.id} className="flex items-center space-x-2 mb-2">
                      <input
                          type="radio"
                          id={`radio-${item.id}`}
                          name="imageSelection"
                          onChange={() => handleExchangeChange(item.id)}
                          className="checked:bg-accent dark:bg-jacarta-600 text-accent border-jacarta-200 focus:ring-accent/20 dark:border-jacarta-500 h-5 w-5 rounded focus:ring-offset-0 self-center"
                      />
                      <label
                          htmlFor={`radio-${item.id}`}
                          className="dark:text-jacarta-200 text-sm flex items-center"
                      >
                        <img src={item.image} alt={item.name} className="h-10 w-10 mr-2 rounded"/>
                        {item.name}
                      </label>
                    </div>
                ))}
              </div>
            </div>

            {/* <!-- end body --> */}

            <div className="modal-footer">
              <div className="flex items-center justify-center space-x-4">
                {cadrsAmount > 0 && selectedExchange && (
                    //<Confirm_transfer bundle={selectedBundle} exchange={selectedExchange}  />
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={isButtonDisabled}
                        className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                    >
                      {isLoading ? (
                          <div className="flex items-center justify-center">
                            <Spinner /> {/* Display the spinner component */}
                            <span className="ml-2">Transferring...</span>
                          </div>
                      ) : (
                          "Transfer"
                      )}
                    </button>
                    
                )}
              </div>
            </div>
            {successMessage && (
                <Alert severity="success">
                  {successMessage}
                </Alert>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BidsModal;